import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NgTemplateOutlet} from "@angular/common";
import {ColorValueService} from "../color-value.service";

@Component({
  selector: 'pas-legends2',
  standalone: true,
    imports: [
        NgTemplateOutlet
    ],
  templateUrl: './legends2.component.html',
  styleUrl: './legends2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Legends2Component {
    colorService = inject(ColorValueService)

    legends = this.colorService.legend
}
